import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import ComparisonMode from 'enums/ComparisonMode'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from 'components/share/ErrorMessage'
import { CrosstabWidgetsType } from '../../types'

const CrosstabRowColumnNotSelectedGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<CrosstabWidgetsType>(widgetId)
  const { t } = useTranslation()

  if (ComparisonMode.TOPICS !== widgetSetting.rowComparisonMode) {
    const emptyRow =
      (widgetSetting.rowComparisonMode === ComparisonMode.THEMES &&
        (!widgetSetting.pivotRowThemeInfos || widgetSetting.pivotRowThemeInfos.length === 0)) ||
      (widgetSetting.rowComparisonMode === ComparisonMode.TAGS &&
        (!widgetSetting.rowTagNames || widgetSetting.rowTagNames.length === 0)) ||
      (widgetSetting.rowComparisonMode === ComparisonMode.DOC_HIERARCHIES &&
        (!widgetSetting.rowDocNames || widgetSetting.rowDocNames.length === 0))
    const emptyColumn =
      (widgetSetting.colComparisonMode === ComparisonMode.THEMES &&
        (!widgetSetting.pivotThemeInfos || widgetSetting.pivotThemeInfos.length === 0)) ||
      (widgetSetting.colComparisonMode === ComparisonMode.TAGS &&
        (!widgetSetting.tagNames || widgetSetting.tagNames.length === 0)) ||
      (widgetSetting.colComparisonMode === ComparisonMode.DOC_HIERARCHIES &&
        (!widgetSetting.docNames || widgetSetting.docNames.length === 0))
    if (emptyRow || emptyColumn) {
      return <ErrorMessage>{t('crosstabRowColumnNotSelected')}</ErrorMessage>
    }
  }

  return children
}

export default CrosstabRowColumnNotSelectedGuard
